import { useMutation, useQueryClient } from '@tanstack/react-query'
import { UserFriendlyError } from '../../../model/Error'
import { updateTranscription } from '../../../data/transcriptionAI/updateTranscription'
import { transcriptionAIKeys } from './transcriptionAI.keys'

interface TranscriptionMutateVariable {
  transcriptionUuid: string
  file: Blob
}

export const useUpdateTranscription = () => {
  const queryClient = useQueryClient()

  return useMutation<any, Error, TranscriptionMutateVariable>({
    mutationFn: async ({ transcriptionUuid, file }) => {
      const { data, ok } = await updateTranscription(file, transcriptionUuid)
      if (!data || !ok) {
        throw new UserFriendlyError('error', 'La mise à jour de la transcription a échoué')
      }

      queryClient.setQueryData(transcriptionAIKeys.detail(data.uuid), data.transcript)
      const oldData = queryClient.getQueryData(transcriptionAIKeys.detail(data.uuid))
      const newData = Array.isArray(oldData) ? [...oldData, data.transcript] : [data.transcript]

      queryClient.setQueryData(transcriptionAIKeys.detail(data.uuid), newData)

      return [newData, data.transcript]
    },
  })
}
